import clsx from 'clsx';
import {
  BottomSheet as _BottomSheet,
  BottomSheetProps as _BottomSheetProps,
} from 'react-spring-bottom-sheet';

import 'react-spring-bottom-sheet/dist/style.css';
import styles from './styles.module.scss';
import useBoundStore from 'store';
import imgLogo from 'assets/images/logo-black.svg';

export type BottomSheetProps = {
  noPadding?: boolean;
  noScroll?: boolean;
  header?: React.ReactNode;
} & _BottomSheetProps;

const BottomSheet: React.FC<BottomSheetProps> = (props) => {
  const { children, noPadding, noScroll, header, ...rest } = props;
  const keyBoardHeight = useBoundStore((s) => s.keyBoardHeight);
  const isShowKeyBoardHeight = useBoundStore((s) => s.isShowKeyBoardHeight);

  return (
    <_BottomSheet
      header={header ? header : <img alt='Логотип itreit' src={imgLogo} width={100} />}
      {...rest}
    >
      <div className={clsx(!noPadding && styles.container, noScroll && styles.noScroll)}>
        {children}
      </div>

      {!!isShowKeyBoardHeight && (
        <div className={styles.stretchableBlock} style={{ height: Number(keyBoardHeight - 15) }} />
      )}
    </_BottomSheet>
  );
};

export default BottomSheet;
